import { render, staticRenderFns } from "./PaginaFinal.vue?vue&type=template&id=1ba18b6c&"
import script from "./PaginaFinal.vue?vue&type=script&lang=js&"
export * from "./PaginaFinal.vue?vue&type=script&lang=js&"
import style0 from "./PaginaFinal.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports